module.exports = __webpack_public_path__ + "static/ndc-logo-d00b35afb0740eb035285fb993d480fb.png";